import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import { Loading, Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import { Howl } from 'howler';
import './element-variables.scss'

Vue.use(router)
Vue.use(ElementUI);

Vue.prototype.$axios = axios;

// 在页面加载时检查是否需要播放音频
document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const shouldPlay = urlParams.get('autoplay') !== 'false';
  if (shouldPlay) {
    axios.get("/api/set/get").then(res => {
      const srcMp3 = res.data.data.bg_music
      const src = `/api/file/download/${srcMp3}`;
      // console.log(src)
      var sound = new Howl({
        src: [src],
        volume: 0.6,
        loop: true
      });
      sound.play();
    }).catch(error => {
      console.error("加载背景音乐失败:", error);
    });
  }
});

// axios.get("/api/backgroundAudio/list").then(res => {
//   const srcMp3 = res.data.data.items[0].value;
//   const src = `/api/file/download/${srcMp3}`;

//   var sound = new Howl({
//     src: [src],
//     volume: 0.25,
//     loop: true
//   });
//   sound.play();
// }).catch(error => {
//   console.error("加载背景音乐失败:", error);
// });


// axios.defaults.baseURL = 'http://localhost:6060';

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 检查请求方法是否为 POST
  if (config.method === 'post' && config.data) {
    const formData = new FormData()

    // 将 config.data 中的所有参数添加到 FormData
    for (const key in config.data) {
      if (Object.prototype.hasOwnProperty.call(config.data, key)) {
        formData.append(key, config.data[key])
      }
    }

    // 将 FormData 赋值给 config.data
    config.data = formData
  }

  return config
}, error => {
  return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error);
});


// 全局变量：记录当前活跃请求数量和Loading实例
let activeRequests = 0
let loadingInstance = null

// 请求拦截器 
axios.interceptors.request.use(config => {
  // 请求计数器+1
  activeRequests++

  // 显示全屏Loading（首个请求时触发）
  if (activeRequests === 1) {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '加载中...',
    })
  }

  return config
})

// 响应拦截器
const handleResponse = () => {
  // 请求计数器-1
  activeRequests = Math.max(0, activeRequests - 1)

  // 关闭Loading（当无活跃请求时）
  if (activeRequests === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}
axios.interceptors.response.use(
  response => {
    handleResponse(response)

    if (response.data.status != 0) {
      Message.error({
        message: response.data.msg
      })
    }

    return response
  },
  error => {
    handleResponse()
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')